/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Student_Log_PaymentInputs */

const en_student_log_payment = /** @type {(inputs: Student_Log_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log payment`)
};

const he_student_log_payment = /** @type {(inputs: Student_Log_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`רישום תשלום`)
};

/**
* | output |
* | --- |
* | "Log payment" |
*
* @param {Student_Log_PaymentInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const student_log_payment = /** @type {((inputs?: Student_Log_PaymentInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Student_Log_PaymentInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_student_log_payment(inputs)
	return he_student_log_payment(inputs)
});